// extracted by mini-css-extract-plugin
export default {"selectMenu":"AssigneeList_selectMenu__f8Jly","cutomStyle":"AssigneeList_cutomStyle__SO5Br","option":"AssigneeList_option__s8kw9","options":"AssigneeList_options__f8kOD"};